import request from '@/utils/request'

export function loginByToken(token) {
  return request({
    url: '/cas-server/refreshToken2',
    method: 'post',
    data: { data: {token} }
  })
}

export function loginByUsername(data) {
  return request({
    url: '/cas-server/doLogin',
    method: 'post',
    data: { data: data }
  })
}

export function loginByCode(data) {
  return request({
    url: '/cas-server/dynamicLogin',
    method: 'post',
    data: { data: data }
  })
}

export function loginByQRcode(data) { // 微信二维码登录
  return request({
    url: '/cas-server/qrcodeLogin',
    method: 'post',
    data: { data: data }
  })
}

export function getValidatorCode(params) { // 登陆验证码
  return request({
    url: '/cas-server/validator/login/sendValidatorCode',
    method: 'post',
    data: params
  })
}

export function getBindCodePhone(params) { // 绑定手机验证码
  return request({
    url: '/message/sms/sendBindCode',
    method: 'post',
    data: params
  })
}

export function getBindCodeEmail(params) { // 绑定邮箱验证码
  return request({
    url: '/message/email/sendBindCodeEmail',
    method: 'post',
    data: params
  })
}

export function userBind(params) { // 用户绑定手机&邮箱
  return request({
    url: '/ways-config/user/bind',
    method: 'post',
    data: params
  })
}

export function bindQRCode(params) { // 绑定微信
  return request({
    url: '/cas-server/pc/wx/v1/bindQRCode',
    method: 'post',
    data: params
  })
}

export function getLoginQRCode(params) { // 获取登陆微信二维码
  return request({
    url: '/cas-server/pc/wx/v1/getLoginQRCode',
    method: 'post',
    data: params
  })
}

export function getBindQRCode(params) { // 获取绑定微信二维码
  return request({
    url: '/cas-server/pc/wx/v1/getBindQRCode',
    method: 'post',
    data: params
  })
}

export function getQRCodeStatus(params) { // 获取二维码状态
  return request({
    url: '/cas-server/pc/wx/v1/getQRCodeStatus',
    method: 'post',
    data: params
  })
}

export function logout(token) {
  return request({
    url: '/cas-server/logout',
    method: 'post',
    data: { data: {}, token: token }
  })
}

export function getUserInfo() {
  return request({
    url: '/cas-server/info',
    method: 'get'
  })
}

export function getForeignInfo(params) {
  return request({
    url: '/ajax/auth/foreignLogin',
    method: 'post',
    params: params,
    data: params
  })
}

export function refreshToken(params) {
  return request({
    url: '/cas-server/refreshToken',
    method: 'post',
    data: params
  })
}

export function getMenus() { // 旧菜单，拆分为以下两个接口
  return request({
    url: '/iways-front/product/product-list',
    method: 'get'
  })
}

/**
 * 菜单改版接口
 */

export function getListUserFuncs() { // 所有产品列表
  return request({
    url: '/iways-front/func/listUserFuncs',
    method: 'get'
  })
}

export function getListMenuByFunc(params) { // 单个产品菜单
  return request({
    url: '/iways-front/func/listMenuByFunc',
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js